<template>
  <div>
    <report-header ref="reportHeader"
    @generate="load"
    @filterChanged="filterChanged"
    @onChangedDateStart="onChangedDateStart"
    @onChangedDateEnd="onChangedDateEnd"
    @onChangedGroup="onChangedGroup"
    @onChangeAccsGroup="onChangeAccsGroup"
    @paginationChanged="paginationChanged"
    @limitChanged="limitChanged"
    @download="download"
    :filterOptions="filterOptions"
    :isGenerateDisabled="isGenerateDisabled"/>

    <basic-table id="basicTable" ref="basicTable"
      @Filtred="Filtred"
      :items="payments"
      :fields="paymentsFields"
      :filter="filter"
      :per-page="realPerPage"
      :totalRows="totalRows"
      :isBackEndSort="true"
      @ClickOnRightMouse="onRightClick"
      @SortCallBack="sortChanged"/>
    <table-manager-bottom  ref="tmb"
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <b-modal id="rightClick" :title="$t('Cancel Payment')" hide-footer>
      <b-alert show variant="warning">{{$t('Cancel Payment Warning')}}</b-alert>
      <modal-ok-cancel :saveButtonLabel="'Cancel Payment'" @save="cancelPayment" @cancel="$bvModal.hide('rightClick')" size="md"/>
    </b-modal>
  </div>

</template>

<script>
import moment from 'moment'
import download from 'downloadjs'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        accounting_period_id: 0,
        limit: 5,
        download: 0,
        currentPage: 1,
        perPage: 20,
        filter: '',
        sortField: '',
        isDesc: 0
      },
      userList: [],
      currencies: [],
      methods: [],
      payments: [],
      paymentsFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'external_id', label: this.$i18n.t('External account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'actual_date',
          label: this.$i18n.t('Actual payment time'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === '') return ''
            return this.$root.showDataWithTZDelta(val)
          }},
        {key: 'payment_enter_date',
          label: this.$i18n.t('Time of payment'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === '') return ''
            return this.$root.showDataWithTZDelta(val)
          }},
        {key: 'payment',
          label: this.$i18n.t('Volume'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'payment_incurrency',
          label: this.$i18n.t('Amount (in currency)'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'currency_id', label: this.$i18n.t('Currency'), sortable: true},
        {key: 'method_name', label: this.$i18n.t('Payment method'), sortable: true},
        {key: 'who_recieved', label: this.$i18n.t('Recieved by'), sortable: true},
        {key: 'admin_comment', label: this.$i18n.t('Admin Comment'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'payment_ext_number', label: this.$i18n.t('Payment document'), sortable: true},
        {key: 'burnt_date', label: this.$i18n.t('Expiration date'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: false,
        isNotLimit: true
      },
      rightClickItem: null
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    sortChanged (ctx) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      this.getStore.sortField = ctx.sortBy
      this.getStore.isDesc = ctx.sortDesc ? 1 : 0
      this.load()
    },
    cancelPayment () {
      this.$store.dispatch('Users/CANCEL_PAYMENT', {payment_id: this.rightClickItem.id,
        admin_comment: this.rightClickItem.admin_comment,
        user_comment: this.rightClickItem.comment
      })
      this.$bvModal.hide('rightClick')
    },
    onRightClick (item) {
      this.rightClickItem = item
      this.$bvModal.show('rightClick')
    },
    async load (isGenerateClick = true, currentPage = 1) {
      this.$refs.tmb.setCurrentPage(currentPage)
      this.getStore.currentPage = currentPage
      this.isGenerateDisabled = true
      this.getStore.filter = this.filter ? this.filter : ''
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      var numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_PAYMENTS', this.getStore).then(response => {
        if (isGenerateClick) {
          let tmpPayments = this.$store.getters['Reports/PAYMENTS'].payments
          let tmpSummary = this.$store.getters['Reports/PAYMENTS'].summary
          this.currencies = this.$store.getters['ReferenceBooks/CURRENCIES']
          for (let i in tmpPayments) {
            for (let j in this.currencies) {
              var newCurr = this.currencies[j]
              if (newCurr.currency_id === tmpPayments[i].currency_id) {
                tmpPayments[i].currency_id = this.currencies[j].currency_brief_name
                break
              }
            }
            if (tmpPayments[i].burnt_date) {
              tmpPayments[i].burnt_date = moment(Number(tmpPayments[i].burnt_date) * 1000).format('DD-MM-YYYY HH:mm')
            } else {
              tmpPayments[i].burnt_date = this.$i18n.t('Not defined')
            }
            let credit = tmpPayments[i].admin_comment.includes('CREDIT OPEN UNTIL')
            if (credit) {
              tmpPayments[i].admin_comment = this.$i18n.t('Loan due on: ') + moment(Number(tmpPayments[i].admin_comment.slice(19, 29)) * 1000).format('DD-MM-YYYY HH:mm')
            } else {
              tmpPayments[i].admin_comment = this.$i18n.t(tmpPayments[i].admin_comment)
            }
          }
          for (let i in tmpSummary) {
            tmpSummary[i].account_id = this.$t(tmpSummary[i].account_id)
            tmpSummary[i].currency_id = ''
            tmpSummary[i].actual_date = ''
            tmpSummary[i].payment_enter_date = ''
            tmpSummary[i].burnt_date = ''
          }
          tmpPayments = tmpPayments.concat(tmpSummary)
          this.payments = []
          this.payments = JSON.parse(JSON.stringify(tmpPayments))
        } else {
          download(this.$store.dispatch('Reports/GET_PAYMENTS_DOWNLOAD', this.getStore), 'report_payments_payments.csv', 'text/csv')
        }
        this.$refs.reportHeader.setFilter('')
        this.loadDone()
      })
      this.totalRows = this.$store.getters['Reports/PAYMENTS'].total_rows
      this.$emit('input', this.totalRows)
    },
    async download () {
      let resp = await this.$store.dispatch('Reports/GET_PAYMENTS_DOWNLOAD', this.getStore)
      download(resp.data, 'report_payments_payments.csv', 'text/csv')
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = value
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  watch: {
    currentPage: function (val) {
      this.getStore.currentPage = val
      this.load(true, val)
    },
    perPage: function (val) {
      this.getStore.perPage = val
      this.load(true, this.currentPage)
    }
  },
  computed: {
    realPerPage () {
      let additionalSumRows = this.$store.getters['Reports/PAYMENTS'].summary ? this.$store.getters['Reports/PAYMENTS'].summary.length : 0
      return this.perPage + additionalSumRows
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_PAYMENT_METHODS')
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.loadDone()

    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/payments/main.vue